import { Typography } from "@mui/material";
import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { MerSetaSdiSearchDto } from "../../../../../Component/Model/Dto/WSP/MerSETASDI";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";

interface organisationSDITrainingRows {
    startEndDate: string,
    beeCategory: string,
    interventionType: string,
    interventionTitle: string,
    courseName: string,
    trainers: JSX.Element,
    actions: ActionType[];
}

interface organisationSDITrainingTable {
    columns: Array<TableColumn>;
    rows: Array<organisationSDITrainingRows>;
}
export function OrganisationSDITrainingDataTable(dataObject: MerSetaSdiSearchDto[], editMerSetaSdi: (id: number) => void, deleteMerSetaSdi: (id: number, courseName: string) => void, handleRouteToTrainerClick: (id: number) => void, handleRouteToAttendeeClick: (id: number) => void): organisationSDITrainingTable {
    const columns = [
        { Header: 'Start - End Date', accessor: 'startEndDate', id: 'startEndDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'BEE Category', accessor: 'beeCategory', id: 'beeCategory', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Intervention Type', accessor: 'interventionType', id: 'interventionType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Intervention Title', accessor: 'interventionTitle', id: 'interventionTitle', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Course Name', accessor: 'courseName', id: 'courseName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Attendees', accessor: 'attendees', id: 'attendees', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Trainers', accessor: 'trainers', id: 'trainers', Cell: ({ value }: any) => value, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },

    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: MerSetaSdiSearchDto, index: number) => ({
            startEndDate: item.startEndDate,
            beeCategory: item.beeCategory,
            interventionType: item.interventionType,
            interventionTitle: item.interventionTitle,
            courseName: item.courseName,
            attendees: (
                <Typography variant="caption" fontWeight='regular' color="#007bff"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    handleRouteToAttendeeClick(item.id);
                }}>
                    {item.attendees}
                </Typography>
            ),
            trainers: (
                <Typography
                    variant="caption" fontWeight='regular' color="#007bff"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        handleRouteToTrainerClick(item.id);
                    }}
                >
                    {item.trainers}
                </Typography>
            ),
            actions: [
                {
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        editMerSetaSdi(item.id);
                    },
                    icon: {
                        color: 'info',
                        name: 'edit'
                    }
                },
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteMerSetaSdi(item.id, item.courseName);
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
